export default __webpack_public_path__ + "static/media/partenaire.f03e2bf7.jpg";